import { Component, Input, OnInit } from '@angular/core';
import { Device } from "../../../../model/device";
import { DevicesService } from "../../../../services/devices.service";
import { DeviceMeasurement } from "../../../../model/device-measurement";
import { translate } from "@ngneat/transloco";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-device-sensors',
  templateUrl: './device-sensors.component.html',
  styleUrls: ['./device-sensors.component.scss']
})
export class DeviceSensorsComponent implements OnInit {

  @Input()
  public device: Device;

  public measurements: DeviceMeasurement[];
  public selectedMeasurements: DeviceMeasurement[];
  public totalMeasurements: number;
  public loadingMeasurements: boolean;

  public activeButtonState: boolean;
  public rows = 10;
  public first = 0;

  constructor(private devicesService: DevicesService,
              private messageService: MessageService) {
    this.selectedMeasurements = [];
  }

  ngOnInit(): void {
    this.loadMeasurements();
  }

  private loadMeasurements() {
    this.loadingMeasurements = true;
    this.measurements = new Array(this.rows);
    this.devicesService.getDeviceMeasurementsOfDevice(this.device.uuid)
      .subscribe(response => {
        this.measurements = response.deviceMeasurements;
        this.totalMeasurements = this.measurements.length;
        this.loadingMeasurements = false;
      });
  }

  evaluateActiveButtonState() {
    let state = undefined;
    this.selectedMeasurements.forEach(measurement => {
      if(measurement.displayInAsset == true) {
        state = true;
      } else if(measurement.displayInAsset == false) {
        if(state == undefined) {
          state = false;
        }
      }
    });
    this.activeButtonState = !state;
  }

  changeDisplayInAsset() {
    this.devicesService.updateDisplayInAsset(this.selectedMeasurements, !this.activeButtonState).toPromise().then(() => {
      let summary = translate('success.generic.changesApplied');
      let detail = translate('success.deviceMeasurements.changedDisplayInAsset');
      this.messageService.clear();
      this.messageService.add({severity:'success', summary: summary, detail: detail});
      this.selectedMeasurements.forEach(measurement => {
        measurement.displayInAsset = !this.activeButtonState;
      });
      this.selectedMeasurements = [];
    });
  }

  changeIndividualDisplayInAsset(measurement: DeviceMeasurement) {
    this.devicesService.updateDisplayInAsset([measurement], !measurement.displayInAsset).toPromise().then(() => {
      let summary = translate('success.generic.changesApplied');
      let detail = translate('success.deviceMeasurements.changedDisplayInAsset');
      this.messageService.clear();
      this.messageService.add({severity:'success', summary: summary, detail: detail});
      this.selectedMeasurements = [];
      measurement.displayInAsset = !measurement.displayInAsset;
    });
  }

}
